import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import MapPage from './pages/MapPage';
import EidogenPage from './pages/EidogenPage';
import EidonomiconPage from './pages/EidonomiconPage';
import EncryptidsPage from './pages/EncryptidsPage';

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent: React.FC = () => {
  const location = useLocation();
  const currentPage = location.pathname.slice(1) || 'Home';

  return (
    <Layout currentPage={currentPage}>
      <Routes>
        <Route path="/" element={<MapPage />} />
        <Route path="/eidogen" element={<EidogenPage />} />
        <Route path="/eidonomicon" element={<EidonomiconPage />} />
        <Route path="/encryptids" element={<EncryptidsPage />} />
      </Routes>
    </Layout>
  );
};

export default App;